import {
  Box,
  Button,
  Flex,
  Heading,
  Input,
  InputGroup,
  InputLeftElement,
  Text,
  VStack,
} from '@chakra-ui/core';
import { ChevronLeftIcon, ChevronRightIcon } from '@chakra-ui/icons';
import React, { useState } from 'react';
import { BeatLoader } from 'react-spinners';
import InfoCheckStack from '../../../components/InfoCheckStack';
import useDebounce from '../../../hooks/useDebounce';
import useDidMountEffect from '../../../hooks/useDidMountEffect';
import { getTwitterInfo } from '../../../services/twitter';

interface SetupInfluencerTwitterProps {
  onNext: () => void;
  setTwitterInfo: (any) => void;
  twitterInfo: any;
  onBack?: () => void;
}

const SetupInfluencerTwitter = ({
  onNext,
  setTwitterInfo,
  twitterInfo,
  onBack,
}: SetupInfluencerTwitterProps) => {
  const [twitterHandle, setTwitterHandle] = useState<string | undefined>();
  const debouncedTwitterHandle = useDebounce(twitterHandle, 1000);
  const [isLoadingTwitterHandle, setIsLoadingTwitterHandle] = useState(false);

  useDidMountEffect(() => {
    setIsLoadingTwitterHandle(true);
    (async () => {
      try {
        const _twitterInfo = await getTwitterInfo(twitterHandle);
        setTwitterInfo(_twitterInfo);
        console.log(_twitterInfo);
      } catch (e) {
        console.error('not found');
      } finally {
        setIsLoadingTwitterHandle(false);
      }
    })();
  }, [debouncedTwitterHandle]);

  return (
    <Flex flexDir="column">
      <Flex
        flexDir="column"
        bg="#1da1f2"
        alignItems="center"
        minH="200px"
        flex={1}
        borderRadius={4}
      >
        <Text color="white" my={2}>
          Your Profile
        </Text>
        <Flex display="flex" alignItems="center" w="330px" h="140px">
          <Flex
            bg="white"
            w="full"
            h="full"
            p={4}
            borderRadius={8}
            alignItems="center"
            justifyContent="center"
          >
            {isLoadingTwitterHandle ? (
              <BeatLoader />
            ) : (
              <VStack alignItems="center" spacing={2} w="inherit">
                {twitterInfo ? (
                  <>
                    <Box
                      borderRadius={100}
                      boxSize="50px"
                      bg="#EBEBEB"
                      background={`url(${twitterInfo.profile_image_url_https.replace(
                        'normal',
                        '200x200'
                      )})`}
                      backgroundSize="cover"
                    ></Box>

                    <Text
                      w="80%"
                      textAlign="center"
                      fontWeight="bold"
                      overflow="hidden"
                      whiteSpace="nowrap"
                      textOverflow="ellipsis"
                    >
                      {twitterInfo.name}
                    </Text>
                    <Text
                      w="100%"
                      textAlign="center"
                      fontSize="xs"
                      overflow="hidden"
                      whiteSpace="nowrap"
                      textOverflow="ellipsis"
                    >
                      {twitterInfo.description}
                    </Text>
                  </>
                ) : (
                  <>
                    <Box borderRadius={100} boxSize="50px" bg="#EBEBEB"></Box>

                    <Box borderRadius={8} h="15px" w="80%" bg="#EBEBEB"></Box>
                    <Box borderRadius={8} h="15px" w="100%" bg="#EBEBEB"></Box>
                  </>
                )}
              </VStack>
            )}
          </Flex>
        </Flex>
      </Flex>
      <Flex flex={1} flexDir="column">
        <Flex display="flex" alignItems="center" mt={4} justifyContent="center">
          <Heading as="h4" size="xs">
            We'll automatically import your Twitter profile, name, and bio.
          </Heading>
        </Flex>
        <Flex display="flex" mt={4} flexDir="column" alignItems="center">
          <InputGroup w="fit-content">
            <InputLeftElement pointerEvents="none" children="@" />
            <Input
              autoComplete="off"
              placeholder="TwitterHandle"
              w="200px"
              mb={4}
              onChange={(evt) => setTwitterHandle(evt.target.value)}
            />
          </InputGroup>

          <Text fontWeight="bold" fontSize="xs" mb={2}>
            We are just pulling your public Twitter profile data.
          </Text>
          <InfoCheckStack
            infoStrings={[
              'No sign-in required',
              'No Twitter authentication required',
            ]}
          />
        </Flex>

        <Flex flexDir="row" m={4}>
          {onBack && (
            <Button leftIcon={<ChevronLeftIcon />} onClick={onBack}>
              Go Back
            </Button>
          )}
          <Button
            ml="auto"
            alignSelf="flex-end"
            colorScheme="blue"
            rightIcon={<ChevronRightIcon />}
            onClick={onNext}
            disabled={!twitterInfo}
          >
            Verify Twitter Profile
          </Button>
        </Flex>
      </Flex>
    </Flex>
  );
};

export default SetupInfluencerTwitter;
